import fileTypes from '../store/modules/file-types';
import parapheurs from '../store/modules/parapheurs';
import signatory from '../store/modules/signatory';
import settingsGroups from '../store/modules/settings-groups';
import settingsUsers from '../store/modules/settings-users';
import auth from '../store/modules/auth';
import templates from '../store/modules/templates';
import organizations from '../store/modules/organizations';
import certificate from '../store/modules/certificate';
import preferences from '../store/modules/preferences';
import ui from '../store/modules/ui';

export default {
  namespaced: true,
  modules: {
    fileTypes,
    parapheurs,
    signatory,
    settingsGroups,
    settingsUsers,
    auth,
    templates,
    organizations,
    certificate,
    preferences,
    ui,
  },
};
